import React from 'react';
import HomePage from './pages/HomePage';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-100">
      <HomePage />
    </div>
  );
}

export default App;